const translations = {
  "en": {
    "Added": "Added",
    "Entry": "Entry",
    "Sold Out": "Sold Out",
    "Trimmed": "Trimmed",
    "Unchanged": "Unchanged"
  },
  "zh-tw": {
    "Added": "增持",
    "Entry": "建倉",
    "Sold Out": "清倉",
    "Trimmed": "減持",
    "Unchanged": "不變"
  }
};

export default translations;
